import { defineMessages } from 'react-intl';

export default defineMessages({
  'Завантаження...': {
    id: 'loading:label',
    defaultMessage: 'Завантаження...',
  },
});
